import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/features/auth'
import { RechargeOrders } from '@/features/recharge-orders'

export const Route = createFileRoute('/_authenticated/recharge-orders/')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user?.role !== 'admin' && auth.user?.role !== 'super_admin') {
      throw redirect({ to: '/403' })
    }
  },
  component: RechargeOrders,
})
